import React from 'react';

import { useSystem } from '@core';
import { useDicomPrint } from '@ui/contextProviders';
import AboutButton from '../AboutModal/AboutButton';
import QRScanButton from '../QRScanModal/QRScanButton';
import ShareLinkButton from '../ShareLinkModal/ShareLinkButton';
import ToolbarButton from '../ToolbarButton';

export const AddOnButtons = () => {
	const { commandsManager } = useSystem();
	const { state, toggleDicomPrintMode } = useDicomPrint();
	return (
		<div className="flex items-center" id="add-on">
			{!state.endablePrintDicomMode ? (
				<>
					<QRScanButton />
					<ShareLinkButton />
					<ToolbarButton
						icon={'expand'}
						label={'Full screen'}
						onInteraction={() => {
							commandsManager.run({
								commandName: 'toggleFullscreen',
								commandOptions: {},
							});
						}}
						id="expand"
						type="action"
					/>
					<AboutButton />
				</>
			) : (
				<ToolbarButton
					icon={'close'}
					label={'Close'}
					onInteraction={() => {
						commandsManager.run({
							commandName: 'setHangingProtocol',
							commandOptions: {
								protocolId: 'default',
								isHangingProtocolLayout: false,
								initialImageOptions: {
									preset: 'middle',
								},
								// stageIndex: 0
							},
						});
						toggleDicomPrintMode();
					}}
					id=""
					dropdownContent=""
					type="action"
				/>
			)}
			{/* <span className="mr-3 text-lg text-common-light">{t('INVESTIGATIONAL USE ONLY')}</span> */}
		</div>
	);
};
